import React from 'react'
import EventList from '_pages/Event/EventList'

function AllPage() {
  return (
    <div className='size-width-desktop-sm'>
      <EventList />
    </div>
  )
}

export default AllPage
